import { LANGUAGES } from '@/utils/constants'

const { PORTUGUESE, ENGLISH, SPANISH } = LANGUAGES

export const CHOOSE_CHART_COLOR = 'choose chart color'
export const APPLY = 'apply'
export const ONE_COLOR = 'one color'
export const MULTIPLE_COLOR = 'multiple color'
export const CHOOSE_DATA_FORMAT = 'choose data format'
export const NUMBER = 'number'
export const PERCENTAGE = 'percentage'

export default {
  [PORTUGUESE]: {
    [CHOOSE_CHART_COLOR]: 'Escolha as cores para o gráfico',
    [APPLY]: 'Aplicar',
    [ONE_COLOR]: 'Uma cor',
    [MULTIPLE_COLOR]: 'Múltiplas Cores',
    [CHOOSE_DATA_FORMAT]: 'Escolha o formato do dado',
    [NUMBER]: 'Número',
    [PERCENTAGE]: 'Porcentagem',
  },

  [ENGLISH]: {
    [CHOOSE_CHART_COLOR]: 'Choose colors for the chart',
    [APPLY]: 'Apply',
    [ONE_COLOR]: 'One Color',
    [MULTIPLE_COLOR]: 'Multiple Colors',
    [CHOOSE_DATA_FORMAT]: 'Choose data format',
    [NUMBER]: 'Number',
    [PERCENTAGE]: 'Percentage',
  },

  [SPANISH]: {
    [CHOOSE_CHART_COLOR]: 'Elige colores para el gráfico',
    [APPLY]: 'Aplicar',
    [ONE_COLOR]: 'Un color',
    [MULTIPLE_COLOR]: 'Múltiples Colores',
    [CHOOSE_DATA_FORMAT]: 'Elegir formato de datos',
    [NUMBER]: 'Número',
    [PERCENTAGE]: 'Porcentaje',
  },
}
